import React, { FC } from "react";
import { Trans, useTranslation } from "next-i18next";
import styles from "./OlympiadPartnerHero.module.scss";
import { UnderlineLink } from "@climate-science/component-library";
import { NextSeo } from "next-seo";
import Partners from "@cs/screens/partners/Partners";


const OlympiadPartnersHero: FC = () => {
  const { t } = useTranslation("olympiad");

  return (
    <>
      <NextSeo
        title={t("campaign-partners")}
      />
      <section className={styles.cso22}>
        <p className={styles.thanksTo}>
          {t("thanks-to-our-partners")}
        </p>
        <h1
          className={styles.title}>
          <Trans
            t={t}
            i18nKey="The CSO22 is already in 112 countries"
            components={[
              <HighlightedText key={"0"} />
            ]}
          />
        </h1>
        <h2 className={styles.heading2}>{t("global-partners")}</h2>
        <Partners />
        <p className={styles.text}>
          <Trans
            t={t}
            i18nKey="gov-cities-school3"
            components={[
              <UnderlineLink key="0" href="mailto:kanika@climatescience.org" />,
              <UnderlineLink
                key="1" href="https://forms.gle/KT4enWvq292oeQFj8"
                target="_blank" rel="noreferrer"
              />
            ]}
          />
        </p>
        <h2 className={styles.heading2}>{t("campaign-partners")}</h2>
        <p className={styles.text2}>
          <Trans
            t={t}
            i18nKey="campaign-partner2"
            components={[
              <UnderlineLink
                key="0" href="https://forms.gle/ST9SHtx8jG2STREY9"
                target="_blank" rel="noreferrer"
              />
            ]}
          />
        </p>
      </section>
    </>
  );
};

export default OlympiadPartnersHero;


const HighlightedText: FC = ({ children }) => (
  <span className={styles.highlightedText}>{children}</span>
);